module.exports = __webpack_public_path__ + "img/table_blue.a91c03fb.svg";